/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerResource
 */
export interface FreelancerResource {
    /**
     * 
     * @type {string}
     * @memberof FreelancerResource
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerResource
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerResource
     */
    fullName: string;
}

/**
 * Check if a given object implements the FreelancerResource interface.
 */
export function instanceOfFreelancerResource(value: object): value is FreelancerResource {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    return true;
}

export function FreelancerResourceFromJSON(json: any): FreelancerResource {
    return FreelancerResourceFromJSONTyped(json, false);
}

export function FreelancerResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerResource {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'identityId': json['identityId'],
        'fullName': json['fullName'],
    };
}

export function FreelancerResourceToJSON(value?: FreelancerResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'identityId': value['identityId'],
        'fullName': value['fullName'],
    };
}

